export default "__VITE_ASSET__Dl0vWLWf__"